import { Link } from "react-router-dom"
import { CelesteShortcutWrapper } from "./styles"

export const CelesteShortcut = () => {
    return (
        <Link to='celeste'>
            <CelesteShortcutWrapper title="Celeste (Product Details)"></CelesteShortcutWrapper>
        </Link>
    )
}